import { useWizard } from "react-use-wizard";
import NavigateBack from "../../components/navigateBack";
import createPersistedState from "use-persisted-state";
import Mobile from "../../components/mobile";
import { useState } from "react";

const useTokenState = createPersistedState("token");

function MobileStep({
  qKey,
  question,
  descriptions = [],
  labelText,
  onSubmitHandler,
  patientId = null,
  state,
}) {
  //TODO: Discuss with Sanyam, is there a better way to save tokens?
  const [_, setToken] = useTokenState({});
  const { previousStep, nextStep } = useWizard();
  const _qKey = qKey;
  const [isFetchingData, setIsFetchingData] = useState(false);

  const getURL = (mobileNumber) => `/api/v1/users/register/otp/${mobileNumber}`;
  const getMaskedInputURL = (userId) =>
    `/api/v1/users/register/recover/otp/${userId}`;

  const onNextFn = (data) => {
    setIsFetchingData(true);
    let mobileNumber = data;
    //console.log(mobileNumber);
    //console.log(patientId);
    if (patientId !== null && mobileNumber.includes("XX")) {
      //TODO: Find a better way to know if phone is masked
      fetch(getMaskedInputURL(patientId), { method: "GET" })
        .then((response) => response.json())
        .then((responseData) => {
          setIsFetchingData(false);
          if (responseData["status"]["success"]) {
            setToken(responseData["tid"]);
            onSubmitHandler({ [_qKey]: data });
            nextStep();
          }
        });
    } else {
      fetch(getURL(mobileNumber), { method: "POST" })
        .then((response) => response.json())
        .then((responseData) => {
          setIsFetchingData(false);
          if (responseData["status"]["success"]) {
            setToken(responseData["tid"]);
            onSubmitHandler({ [_qKey]: data });
            nextStep();
          }
        });
    }
  };

  return (
    <>
      <NavigateBack onClickHandler={previousStep} />
      <Mobile
        question={question}
        descriptions={descriptions}
        labelText={labelText}
        inputResponseText={state || ""}
        isLoading={isFetchingData}
        onSubmitHandler={onNextFn}
      />
    </>
  );
}

export default MobileStep;
